import ReactPDF, {StyleSheet} from "@react-pdf/renderer";

type MappedStyles<T> = Record<keyof T, ReactPDF.Style> | ReactPDF.Styles;

export function createStylesheet<T extends Record<string, ReactPDF.Style>>(styles: T): MappedStyles<T> {
    return StyleSheet.create(styles as ReactPDF.Styles);
}
